module.exports = __webpack_public_path__ + "img/word_carpet.981fc41a.png";